import { RootState } from '@client/redux/types';
import { combineReducers, Reducer } from 'redux';

import { getReducer as getAbtestingReducer } from '@pegasus/abtesting';
import { getPlatformJourneyReducer } from '@pegasus/platform-journeys';
import cart, { NAMESPACE as CART_NS } from '@client/lib/cart/redux/reducer';
import mylounge from './modules/mylounge/reducer';
import clientDevice from './modules/clientDevice/reducer';
import customer from './modules/customer/reducer';
import user from './modules/user/reducer';
import flashMessage from './modules/flashMessage/reducer';
import tracking from './modules/tracking/reducer';
import myloungeMetadata from './modules/myloungeMetadata/reducer';
import newsletter from './modules/newsletter/reducer';

const abtestingReducer = getAbtestingReducer()['@pegasus/abtesting'] as Reducer;

export default combineReducers<RootState>({
    '@pegasus/abtesting': abtestingReducer,
    [CART_NS]: cart,
    clientDevice,
    customer,
    flashMessage,
    mylounge,
    newsletter,
    tracking,
    user,
    myloungeMetadata,
    ...getPlatformJourneyReducer(),
});
